import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyVivendiMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="vivendiGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#003399", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#0066CC", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#000000", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#vivendiGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 16 }).map((_, wave) => {
          const points: string[] = [];
          const y = -480 + wave * 60;
          for (let p = 0; p <= 40; p++) {
            const t = p / 40;
            const x = -360 + t * 720;
            const yOffset = Math.sin(t * Math.PI * 4 + wave * 0.5) * 30;
            points.push(`${x},${y + yOffset}`);
          }
          return (
            <polyline
              key={`sound-${wave}`}
              points={points.join(" ")}
              fill="none"
              stroke="#0066CC"
              strokeWidth={2}
              opacity={0.25}
            />
          );
        })}
        {Array.from({ length: 18 }).map((_, r) => (
          <circle
            key={`media-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 22}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 3 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.012}
          />
        ))}
        <circle cx={0} cy={0} r={50} fill="none" stroke="#0066CC" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={35} fill="#003399" opacity={0.4} />
      </g>
    </svg>
  );
};
